import { useMemo } from 'react';
import { format, parseISO } from 'date-fns';

export default function useDate(date: string, view: string = 'p') {
  return useMemo(() => format(parseISO(date), view), [date, view]);
}
